<template>


  <v-text-field bg-color="formBackground" variant="solo" placeholder="Search offers" type="text" hide-details
    density="compact" v-model="searchQuery">
  </v-text-field>



</template>

<script>
import { OfferStore } from "@/store/offerStore";
import { ref, watch } from "vue";

export default {
  name: "OfferSearch",
  setup() {
    const offerStore = OfferStore();
    const searchQuery = ref(offerStore.offersParameters.search_query);

    let typingTimer = null;
    const delay = 1000;

    const delaySearch = () => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        offerStore.offersParameters.search_query = searchQuery.value;
      }, delay);
    };

    watch(() => searchQuery.value, () => {
        delaySearch();
      },
      { immediate: true }
    );

    return { offerStore, searchQuery };
  },
};
</script>
